import React, { ReactNode, useReducer } from 'react';
import { searchReducer, SearchAction } from '../reducers/searchReducer';
import { defaultSearchContext, SearchContextType } from '../models/search.interface';

export const SearchContext = React.createContext<{
  state: SearchContextType;
  dispatch: React.Dispatch<SearchAction>
}>({
  state: defaultSearchContext,
  dispatch: () => undefined,
});

export type Props = {
  children: ReactNode;
};

export const SearchContextProvider = ({ children }: Props) => {
  const [ state, dispatch] = useReducer(searchReducer, defaultSearchContext);

  return (
    <SearchContext.Provider value={{state, dispatch}}>
      {children}
    </SearchContext.Provider>
  );
};

export function useSearchContext() {
  const context = React.useContext(SearchContext)
  
  if(context === undefined){
    throw new Error('useSearchContext must be used within a SearchContextProvider')
  }

  return context;
}
  
export const SearchContextConsumer = SearchContext.Consumer;

export default { SearchContextProvider, SearchContextConsumer };
